import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

// 워치 도그 생성
export const createWatchdog = async (payload) => {
  const res = await axios.post(`${baseUrl}/salus-watchdog`, payload)
  return res?.data
}

// 워치 도그 수정
export const updateWatchdog = async (payload) => {
  // {
  //   "id": 0,
  //   "title": "string",
  //   "startDate": "2026-01-28",
  //   "endDate": "2026-01-28",
  //   "teamGroupId": 0,
  //   "memo": "string",
  //   "isFixed": false(고정)
  // }
  const res = await axios.put(
    `${baseUrl}/salus-watchdog/${payload.id}`,
    payload,
  )
  return res?.data
}

// 워치 도그 삭제
export const deleteWatchdog = async (id) => {
  const res = await axios.delete(`${baseUrl}/salus-watchdog/${id}`)
  return res?.data
}

// 워치 도그 조회 (팀)
export const getWatchdogListByTeam = async (teamGroupId) => {
  const res = await axios.get(
    `${baseUrl}/salus-watchdog/list/teams/${teamGroupId}`,
  )
  return res?.data
}

// 워치 도그 조회 (스튜디오: 해당 스튜디오 내 모든 팀 통합)
export const getWatchdogListByStudio = async (studioGroupId) => {
  const res = await axios.get(
    `${baseUrl}/salus-watchdog/list/studios/${studioGroupId}`,
  )
  return res?.data
}

// 과거 팁 기준 조회
export const getPastWatchdogListByTeam = async (teamGroupId) => {
  const res = await axios.get(
    `${baseUrl}/salus-watchdog/past-list/teams/${teamGroupId}`,
  )
  return res?.data
}
// 과거 스튜디오 기준 조회
export const getPastWatchdogListByStudio = async (studioGroupId) => {
  const res = await axios.get(
    `${baseUrl}/salus-watchdog/past-list/studios/${studioGroupId}`,
  )
  return res?.data
}

// 워치 도그 상세
export const getWatchdogDetail = async (id) => {
  const res = await axios.get(`${baseUrl}/salus-watchdog/${id}`)
  return res?.data
}

// --------------------------------
// -----------🔥 워치도그 TASK 관련 API---------------
// --------------------------------
export const createWatchdogTask = async (payload) => {
  // {
  //   "watchdogId": 0,
  //   "title": "string",
  //   "endDateTime": "2026-01-28T14:38:38.904Z",
  //   "memo": "string",
  //   "subTaskTitles": [
  //     "string"
  //   ],
  //   "managerIds": [
  //     0
  //   ]
  // }
  const res = await axios.post(`${baseUrl}/salus-watchdog/tasks`, payload)
  return res?.data
}

// 워치도그 TASK 상세
export const getWatchdogTaskDetail = async (taskId) => {
  const res = await axios.get(`${baseUrl}/salus-watchdog/tasks/${taskId}`)
  return res?.data
}
export const updateWatchdogTask = async (taskId, payload) => {
  // {
  //   "watchdogId": 0,
  //   "title": "string",
  //   "endDateTime": "YYYY-MM-DD HH:mm:ss",
  //   "memo": "string",
  //   "subTaskTitles": [
  //     "string"
  //   ],
  //   "managerIds": [
  //     0
  //   ]
  // }
  const res = await axios.put(
    `${baseUrl}/salus-watchdog/tasks/${taskId}`,
    payload,
  )
  return res?.data
}
export const deleteWatchdogTask = async (taskId) => {
  const res = await axios.delete(`${baseUrl}/salus-watchdog/tasks/${taskId}`)
  return res?.data
}

export const updateWatchdogTaskSubTaskComplete = async (subTaskId) => {
  const res = await axios.patch(`${baseUrl}/salus-watchdog/${subTaskId}/toggle`)
  return res?.data
}

export const getWatchdogTaskListByTeam = async (userId) => {
  const res = await axios.get(`${baseUrl}/salus-watchdog/tasks/team/${userId}`)
  return res?.data
}

export const updateWatchdogTaskComplete = async (taskId) => {
  const res = await axios.patch(
    `${baseUrl}/salus-watchdog/tasks/${taskId}/toggle`,
  )
  return res?.data
}
